import { io, Socket } from 'socket.io-client';

import { ESocket } from '@enums/api.enum';
import { IdentityTypes } from '@enums/auth.enum';

let socket: Socket | null = null;

const subscribers = new Set<(socket: Socket) => void>();

export const createSocket = (accessToken: string) => {
	if (!socket) {
		socket = io(import.meta.env.VITE_SOCKET_IO_SERVER!, {
			transports: [ESocket.websocket],
			query: { accessToken, userType: IdentityTypes.ClientSecret },
			autoConnect: false,
			withCredentials: true,
		});
		subscribers.forEach((notify) => notify(socket as Socket));
	}
	return socket;
};

export const getSocket = (): Socket | null => socket;

export const onSocketCreated = (notify: (socket: Socket) => void): (() => void) => {
	if (socket) {
		notify(socket);
		return () => undefined;
	}
	subscribers.add(notify);
	return () => {
		subscribers.delete(notify);
	};
};
